module.exports = __webpack_public_path__ + "img/oxford-bg-m.44479bbb.jpg";